<template>
    <div class="card-header pb-0">
        <h2 class="d-inline">{{ $trans.get('__JSON__.Operational integration management') }}
            <div class="pt-1 pb-1 ps-2 pe-2 bg-danger text-white rounded-1 badge"
                style="font-size: 0.7rem; transform: translateY(-0.7rem);">
                {{ getCountOimAppointments() }} </div>
        </h2>
    </div>
    <div class="card-body">
        <table class="table table-striped hover-zoom">
            <thead>
                <tr>
                    <th role="button" @click.prevent="sortColumn = 'name'">
                        {{ $trans.get('__JSON__.Name') }}
                        <i v-if="sortColumn == 'name'" class="fa fa-sort-asc"></i>
                    </th>
                    <th role="button" @click.prevent="sortColumn = 'employee'">
                        {{ $trans.get('__JSON__.Employee') }}
                        <i v-if="sortColumn == 'employee'" class="fa fa-sort-asc"></i>
                    </th>
                    <th>
                        {{ $trans.get('__JSON__.Message') }}
                    </th>
                    <th role="button" @click.prevent="sortColumn = 'created_at'">
                        {{ $trans.get('__JSON__.Created_At') }}
                        <i v-if="sortColumn == 'created_at'" class="fa fa-sort-asc"></i>
                    </th>
                    <th role="button" @click.prevent="sortColumn = 'status_id'">
                        {{ $trans.get('__JSON__.Status') }}
                        <i v-if="sortColumn == 'status_id'" class="fa fa-sort-asc"></i>
                    </th>
                    <th>
                        {{ $trans.get('__JSON__.Annotation') }}
                    </th>
                    <th role="button" @click.prevent="sortColumn = 'appointment_at'">
                        {{ $trans.get('__JSON__.Appointment_At') }}
                        <i v-if="sortColumn == 'appointment_at'" class="fa fa-sort-asc"></i>
                    </th>
                    <th>
                        {{ $trans.get('__JSON__.Action') }}
                    </th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="oimAppointment in sortedOimAppointments" :key="'oa-' + oimAppointment.id">
                    <td>
                        <employee employeelink="1" :employee="oimAppointment.employee" />
                    </td>
                    <td>
                        {{ oimAppointment.employee.employeenumber }}
                    </td>
                    <td>
                        {{
                            getMessageTranslation(oimAppointment.notification.message, oimAppointment.employee.lastname,
                                oimAppointment.employee.forename
                            ) }}
                    </td>
                    <td>
                        {{ formatDate(oimAppointment.created_at) }}
                    </td>
                    <td>
                        {{ getStatusName(oimAppointment.status_id) }}
                    </td>
                    <td>
                        {{ oimAppointment.annotation }}
                    </td>
                    <td>
                        <a class="link" href="">{{ formatDate(oimAppointment.appointment_at) }}</a>
                    </td>
                    <td>
                        <a class="link mr-1" href="" @click.prevent="gotoEdit(oimAppointment.id)">
                            <span class="material-symbols-outlined">
                                edit
                            </span>
                        </a>
                        <a v-if="oimAppointment.resubmission_on !== null" class="text-danger" href="" 
                            @click.prevent="openResubmissionModal(oimAppointment.id, oimAppointment.resubmission_on)">
                            <span class="material-symbols-outlined">
                                timer_play
                            </span>
                            <span class="material-symbols-outlined">
                                priority_high
                            </span>
                        </a>
                        <a v-if="oimAppointment.resubmission_on === null" class="text-primary" href=""
                            @click.prevent="openResubmissionModal(oimAppointment.id, oimAppointment.resubmission_on)">
                            <span class="material-symbols-outlined">
                                snooze
                            </span>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <Teleport to="body">
        <oim-appointment-resubmission-modal id="resubmissionModal" :oimAppointment_id="selectedOimAppointmentId"
            :resubmissionDateProp="selectedOimAppointmentResubmissionDate"
            @saved="refreshData" @abort="repositionPage"/>
    </Teleport>
</template>

<script>
import axios from "axios";
import oimAppointment from "../composables/getOimAppointments";
import getEmployees from "../composables/getEmployees";

export default {

    name: "OimAppointmentsList",

    props: {
        monitor_others: Boolean,
        view_locations: Object,
        oim_appointment_status: Object
    },
    setup(props) {
        const { oimAppointments, oimAppointment_error, loadOimAppointment } = oimAppointment();
        loadOimAppointment(props.monitor_others, props.view_locations);
        const { employees, employees_error, loadEmployees } = getEmployees();
        loadEmployees(null, [
            null
        ]);

        return { oimAppointments, oimAppointment_error, loadOimAppointment, loadEmployees };
    },
    data() {
        return {
            sortColumn: 'created_at',
            oim_appointment_status_obj: this.oim_appointment_status,
            counted: null,
            employee: null,
            hasResubmission: false,
            selectedOimAppointmentId: null,
            selectedOimAppointmentResubmissionDate: null,
            scrollpos: null,
        };
    },
    created() {
        let refreshtime = 600000 + Math.floor(Math.random() * 120000);
        setInterval(this.refreshData, refreshtime)
    },
    computed: {
        sortedOimAppointments() {
            // Div im Blade verstecken, wenn es keine BEMs gibt.
            if (!this.oimAppointments) {
                $('#oimAppointmentContainer').css('display', 'none');
                return null;
            }

            if (this.oimAppointments.length == 0) {
                $('#oimAppointmentContainer').css('display', 'none');
                return null;
            }

            $('#oimAppointmentContainer').css('display', 'block');
            return this.oimAppointments.sort(this.compareAppointment);
        }
    },
    methods: {
        formatDate(date) {
            if (!date) {
                return null;
            }
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2)
                month = '0' + month;
            if (day.length < 2)
                day = '0' + day;

            return [year, month, day].join('-');
        },
        compareAppointment(a, b) {
            if (this.sortColumn == 'created_at') {

                if (a.created_at == b.created_at) {
                    return 0;
                }

                if (a.created_at > b.created_at) {
                    return -1;
                }
                return 1;
            }

            if (this.sortColumn == 'name') {
                if (a.employee.lastname > b.employee.lastname) {
                    return 1;
                }

                if (a.employee.lastname < b.employee.lastname) {
                    return -1;
                }

                if (a.employee.forename > b.employee.forename) {
                    return 1;
                }

                if (a.employee.forename < b.employee.forename) {
                    return -1;
                }

                if (a.created_at < b.created_at) {
                    return 1;
                }

                if (a.created_at > b.created_at) {
                    return -1;
                }

                return 0;
            }

            if (this.sortColumn == 'appointment_at') {
                if (a.appointment_at < b.appointment_at) {
                    return 1;
                }

                if (a.appointment_at > b.appointment_at) {
                    return -1;
                }

                if (a.employee.lastname > b.employee.lastname) {
                    return 1;
                }

                if (a.employee.lastname < b.employee.lastname) {
                    return -1;
                }

                if (a.employee.forename > b.employee.forename) {
                    return 1;
                }

                if (a.employee.forename < b.employee.forename) {
                    return -1;
                }

                if (a.created_at < b.created_at) {
                    return 1;
                }

                if (a.created_at > b.created_at) {
                    return -1;
                }

                return 0;
            }

            if (this.sortColumn == 'employee') {

                if (a.employee.employeenumber > b.employee.employeenumber) {
                    return 1;
                }

                if (a.employee.employeenumber < b.employee.employeenumber) {
                    return -1;
                }

                if (a.created_at < b.created_at) {
                    return 1;
                }

                if (a.created_at > b.created_at) {
                    return -1;
                }

                return 0;
            }

            if (this.sortColumn == 'status_id') {
                if (a.status_id > b.status_id) {
                    return 1;
                }

                if (a.status_id < b.status_id) {
                    return -1;
                }

                if (a.employee.lastname > b.employee.lastname) {
                    return 1;
                }

                if (a.employee.lastname < b.employee.lastname) {
                    return -1;
                }

                if (a.employee.forename > b.employee.forename) {
                    return 1;
                }

                if (a.employee.forename < b.employee.forename) {
                    return -1;
                }

                if (a.created_at < b.created_at) {
                    return 1;
                }

                if (a.created_at > b.created_at) {
                    return -1;
                }

                return 0;
            }
        },
        getStatusName(status_id) {
            let status_name;
            if (!this.oim_appointment_status_obj[status_id]) {
                return status_name = "--";
            }
            else {
                status_name = this.oim_appointment_status_obj[status_id];
                return this.$trans.get("__JSON__." + status_name);
            }
        },
        getMessageTranslation(message, lastname, forename) {
            let message_translated = this.$trans.get("__JSON__." + message);
            let fullname = lastname + ', ' + forename;

            let filled_message_translated = message_translated.replace(":name", fullname)
            return filled_message_translated;
        },
        gotoEdit(id) {
            // oimappointments/?/edit
            let myNewPathname = "oimappointments/" + id + "/edit";
            window.location.pathname = myNewPathname;
        },
        openResubmissionModal(id, resubmissionDate) {
            this.selectedOimAppointmentId = id;
            this.selectedOimAppointmentResubmissionDate = resubmissionDate;
            this.scrollpos = window.scrollY;
            $('#resubmissionModal').modal({ backdrop: 'static', keyboard: false });
            $('#resubmissionModal').modal('show');
        },
        getCountOimAppointments() {
            if (!this.sortedOimAppointments) {
                return counted = 0;
            }
            let counted = this.sortedOimAppointments.length;
            return counted;
        },
        refreshData() {
            this.loadOimAppointment(this.monitor_others, this.view_locations);
            if (this.scrollpos) window.scrollTo(0, this.scrollpos);
        },
        repositionPage() {
            if (this.scrollpos) window.scrollTo(0, this.scrollpos);
        },
    },
}
</script>